import * as React from 'react';
import { Route } from 'react-router';

import { TipsterRouteInfoContext } from '../__providers__/TipsterRouteInfoContext';

interface OwnProps {
  component: any;
  path: string;
  tipsterID: string;
  adjustTracker: string;
  tipsterSlug: string;
}

export const TipsterRoute: React.FC<OwnProps> = ({
  component: Component,
  tipsterID,
  adjustTracker,
  tipsterSlug,
}: any) => {
  return (
    <Route
      render={(props) => {
        return (
          <TipsterRouteInfoContext.Provider
            value={{ tipsterID, adjustTracker, tipsterSlug }}
          >
            <Component
              tipsterID={tipsterID}
              adjustTracker={adjustTracker}
              {...props}
            />
          </TipsterRouteInfoContext.Provider>
        );
      }}
    />
  );
};
